var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._g(_vm._b({class:[{'android-legacy-switch-fix': _vm.isLegacyAndroid}],attrs:{"ripple":!_vm.isLegacyAndroid}},'v-switch',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }